import { Stack } from '@mui/material';
import { Address, IAddress } from './Address';
import { ContactDetails } from './ContactDetails';
import { useIsDesktop } from 'Hooks';
import { MobileContactDetails } from './MobileContactDetails';
import { ITherapySuppliersResult } from 'API/Suppliers/suppliers';
import { OpenClose } from '../OpenClose';

interface IContactInformation {
  data: ITherapySuppliersResult;
  isOpen: Boolean;
}

export const ContactInformation = ({ data, isOpen }: IContactInformation) => {
  const isDesktop = useIsDesktop();

  const addresses: {
    firstAddress: IAddress;
    secondAddress: IAddress;
  } = {
    firstAddress: {
      street: data.firstStreet,
      houseNumber: data.firstHouseNumber,
      cityId: data.firstCityId,
    },
    secondAddress: {
      street: data.secondStreet,
      houseNumber: data.secondHouseNumber,
      cityId: data.secondCityId,
    },
  };

  const contacts = {
    cellPhoneNumber:
      data.cellPhonePrefix && data.cellPhoneNumber
        ? `0${data.cellPhonePrefix}-${data.cellPhoneNumber}`
        : null,
    homePhoneNumber:
      data.homePhonePrefix && data.homePhoneNumber
        ? `0${data.homePhonePrefix}-${data.homePhoneNumber}`
        : null,
    email: data.email,
  };

  return (
    <Stack direction={isDesktop ? 'row' : 'column'}>
      <Address
        addresses={addresses}
        isAccessible={data.hasAccessibilityForHandicapped}
      />
      {isDesktop ? (
        <ContactDetails contacts={contacts} />
      ) : (
        <MobileContactDetails contacts={contacts} />
      )}
      {isDesktop || !isOpen ? <OpenClose isOpen={isOpen} /> : null}
    </Stack>
  );
};
